import { AccountService } from 'common/services/account.service';
import { observable, action, makeObservable } from 'mobx';

class Balance {
  @observable operationsResponse = [];

  constructor() {
    makeObservable(this);
  }

  @action
  fetchOperations(params) {
    return AccountService.getOperations(params)
      .then((data) => {
        this.operationsResponse = data;
        return data;
      })
      .catch((error) => {
        console.error(error);
      });
  }
}

const BalanceStore = new Balance();

export default BalanceStore;
